<template>

    <div class="page">

        <kt-datatable
            :model="techModel"
            :data="listArray"
            :meta="{ tableClass: 'table-bordered' }"
        >
    
        <template #view_actions="scope">

          <kt-dropmenu v-model:visible="actionDropdown['row_' + scope.row.Id]">
            <template #button>
              <button
                  class="btn -btn-outline-primary btn-sm"
                  @click="actionDropdown['row_' + scope.row.Id] = !actionDropdown['row_' + scope.row.Id]"
              >
                <span><i class="fas fa-ellipsis-v"></i></span>
              </button>
            </template>
            <template #dropmenu>
              <ul class="dropdown-menu show">
                <li>
                  <label class="dropdown-item">
                    <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
                      <i class="fa fa-edit"></i> Edit
                    </button>
                  </label>
                </li>
                <li>
                  <label class="dropdown-item">
                    <button class="btn btn-sm btn-outline-danger form-control" @click="deleteRecord(scope.row.Id)">
                      <i class="fa fa-trash"></i> Remove
                    </button>
                  </label>
                </li>
              </ul>
            </template>
          </kt-dropmenu>
          <!--
            <button
                @click="editRecord(scope.row.Id)"
                class="btn -btn-outline-primary btn-sm"
            >
                <span><i class="fas fa-ellipsis-v"></i></span>
            </button>
            -->
        </template>


        <template #after-search="scope">
            <div class="btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>
        
        </kt-datatable>

        <!-- edit / new / etc... -->
        <router-view name="modal"></router-view>

    </div>
    
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { storeToRefs } from "pinia";

import Events from "@/services/Emitter";
import { useTechStore } from '@/stores/TechStore';

import KtModal from '@/components/UI/KtModal.vue';
import KtDatatable from "@/components/UI/KtDatatable.vue";
import { KtDatatableModelProp, KtDatatableData } from "../UI/KtDataTable";
import KtDropmenu from "@/components/UI/KtDropmenu.vue";


const router = useRouter();
const techStore = useTechStore();
const { list } = storeToRefs(techStore);

// Convert the record to an array for the datatable
const listArray = computed(() => Object.values(list.value));

const actionDropdown = ref<Record<string, boolean>>({});

const techModel = [
    {
        name: "Actions",
        label: "Actions",
        type: "actions"
    }, 
    {
        name: "Id",
        display: false,
    },
    {
        name: "TechnicianName",
        label: "Name",
        display: true,
        sortable: true,
    },
    {
        name: "Email",
        label: "Email",
        display: true,
        sortable: true,
    },
    {
        name: "Active",
        label: "Active",
        display: true,
        type: "boolean",
    } 
] as Array<KtDatatableModelProp>;

const update = (val:any) =>
{
  console.debug("update", val);
};


const dismiss = () =>
{
    router.push({
        path: "/"
    });
};

const editRecord = (id: number) =>
{
    router.push({
        path: "/tech/edit/" + id
    });
};

const newRecord = () =>
{
    router.push({
        path: "/tech/edit/new"
    });
};

const refresh = async() =>
{
    Events.emit("loading", true);
    await techStore.reload();
    Events.emit("loading", false);
};

const deleteRecord = async (id: number) =>
{
    // TODO: Implement delete functionality when API is available
    console.warn("Delete functionality not yet implemented for technician ID:", id);
    // await ApiService.deleteTech(id);
    // await refresh();
};

onMounted(async () =>
{
    refresh();
});


</script>